<template>
    <div class="fixed z-50 top-0 left-0 w-screen h-screen bg-slate-100 dark:bg-slate-900 flex flex-col items-center justify-center">
        <div class="w-40 flex items-center justify-between">
            <div class="w-5 h-5 opacity-100 rounded-full theme-color ball"></div>
            <div class="w-5 h-5 opacity-80 rounded-full theme-color ball"></div>
            <div class="w-5 h-5 opacity-60 rounded-full theme-color ball"></div>
            <div class="w-5 h-5 opacity-40 rounded-full theme-color ball"></div>
            <div class="w-5 h-5 opacity-20 rounded-full theme-color ball"></div>
        </div>
        <p class="mt-5 lg:text-lg xl:text-xl text-slate-600">لطفا شکیبا باشید</p>
    </div>
</template>

<script setup>
import { reactive, onMounted, onUnmounted } from 'vue';

let interval = null;

onMounted(() => {
    const balls = reactive(document.querySelectorAll(".ball"));
    let i = 0;
    interval = setInterval(() => {
        balls[i].classList.add("loading");
        if (i > 0) {
            balls[i - 1].classList.remove("loading");
        } else {
            balls[balls.length -1].classList.remove("loading");
        }
        i++;
        if (i == balls.length) {
            i = 0;
        }
    }, 400);
})
onUnmounted(() => {
    clearInterval(interval);
})
</script>

<style scoped>
.loading{
    animation: loading 0.4s ease-out;
}
@keyframes loading {
    50%{
        transform: translateY(-10px);
    }
    100%{
        transform: translateY(0);
    }
}
</style>